<template>
  <div class="canvasAiModelsWrap">
    <el-tabs v-model="activeVendor">
      <el-tab-pane :label="$tt('阿里云')" name="aliyun" />
      <el-tab-pane :label="$tt('腾讯云')" name="tencent" />
    </el-tabs>

    <div v-if="currentVendor && currentVendor.status !== 'ready'" class="coming">
      <i class="el-icon-time" />
      <p>{{ $tt("敬请期待") }}</p>
    </div>

    <template v-else>
      <p class="hint">{{ $tt("开启且未过期的模型按到期日从早到晚自动选用；调用失败会换下一个。") }}</p>
      <div class="toolbar">
        <el-button size="small" icon="el-icon-setting" @click="openVendor">{{ $tt("调用信息") }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openEdit()">{{ $tt("添加模型") }}</el-button>
      </div>
      <div class="card-grid">
        <div
          v-for="row in rows"
          :key="row.id"
          class="model-card"
          :class="{ off: Number(row.enabled) !== 1 }"
          @click="openEdit(row)"
        >
          <div class="icon" :style="{ background: cardColor(row.model_code) }">
            {{ shortName(row.display_name || row.model_code) }}
          </div>
          <div class="meta">
            <div class="name" :title="row.display_name || row.model_code">
              {{ row.display_name || row.model_code }}
            </div>
            <div class="expire">{{ $tt("到期") }} {{ dateText(row.expire_at) || "—" }}</div>
            <div class="switch-row" @click.stop>
              <span>{{ $tt("生效") }}</span>
              <el-switch
                :value="Number(row.enabled) === 1"
                @change="(on) => toggle(row, on)"
              />
            </div>
          </div>
        </div>
      </div>
      <p v-if="!rows.length" class="empty">{{ $tt("还没有模型，点击「添加模型」") }}</p>
    </template>

    <el-dialog :title="$tt('调用信息')" :visible.sync="vendorVisible" width="560px">
      <el-form label-width="110px" size="small">
        <el-form-item :label="$tt('OpenAI 地址')">
          <el-input v-model="vendorForm.base_url" placeholder=".../compatible-mode/v1" />
        </el-form-item>
        <el-form-item label="API Host">
          <el-input v-model="vendorForm.api_host" :placeholder="$tt('可选')" />
        </el-form-item>
        <el-form-item label="API Key">
          <el-input
            v-model="vendorForm.api_key"
            show-password
            :placeholder="vendorForm.api_key_masked || $tt('不填则保持原 Key')"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="vendorVisible = false">{{ $tt("取消") }}</el-button>
        <el-button type="primary" @click="saveVendor">{{ $tt("保存") }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="form.id ? $tt('编辑模型') : $tt('添加模型')" :visible.sync="dialogVisible" width="480px">
      <el-form label-width="100px" size="small">
        <el-form-item :label="$tt('显示名称')">
          <el-input v-model="form.display_name" :placeholder="$tt('卡片上展示的名字')" />
        </el-form-item>
        <el-form-item :label="$tt('模型 Code')">
          <el-input v-model="form.model_code" :placeholder="$tt('控制台里的模型 Code')" />
        </el-form-item>
        <el-form-item :label="$tt('有效期')">
          <el-date-picker
            v-model="form.expire_at"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$tt('免费额度到期日')"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item :label="$tt('生效')">
          <el-switch v-model="form.enabledOn" />
        </el-form-item>
        <el-form-item :label="$tt('备注')">
          <el-input v-model="form.remark" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button v-if="form.id" type="danger" plain @click="removeCurrent">{{ $tt("删除") }}</el-button>
        <el-button @click="dialogVisible = false">{{ $tt("取消") }}</el-button>
        <el-button type="primary" @click="save">{{ $tt("保存") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";

const PALETTE = ["#409EFF", "#67C23A", "#E6A23C", "#F56C6C", "#909399", "#9B59B6", "#1ABC9C"];

export default {
  data() {
    return {
      activeVendor: "aliyun",
      vendors: [],
      rows: [],
      dialogVisible: false,
      vendorVisible: false,
      vendorForm: {
        vendor_code: "aliyun",
        base_url: "",
        api_host: "",
        api_key: "",
        api_key_masked: "",
      },
      form: {
        id: "",
        display_name: "",
        model_code: "",
        expire_at: "",
        enabledOn: true,
        remark: "",
      },
    };
  },
  computed: {
    currentVendor() {
      const list = Array.isArray(this.vendors) ? this.vendors : [];
      return list.find((v) => v.vendor_code === this.activeVendor) || { status: "ready" };
    },
  },
  mounted() {
    this.loadVendors();
  },
  watch: {
    activeVendor() {
      this.loadModels();
    },
  },
  methods: {
    shortName(name) {
      const s = String(name || "AI");
      const parts = s.split(/[-_.]/);
      const a = (parts[0] || "AI").slice(0, 2);
      return a.toUpperCase();
    },
    cardColor(code) {
      let h = 0;
      const s = String(code || "");
      for (let i = 0; i < s.length; i++) h = (h + s.charCodeAt(i) * (i + 1)) % PALETTE.length;
      return PALETTE[h];
    },
    dateText(d) {
      if (!d) return "";
      return moment(d).format("YYYY-MM-DD");
    },
    unwrapList(res) {
      const data = res && res.data;
      if (Array.isArray(data)) {
        return data;
      }
      if (data && Array.isArray(data.result)) {
        return data.result;
      }
      return [];
    },
    loadVendors() {
      this.$request.canvasAiAdminVendors().then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg || "加载厂商失败");
          return;
        }
        this.vendors = this.unwrapList(res);
        this.loadModels();
      });
    },
    loadModels() {
      if (this.currentVendor.status !== "ready") {
        this.rows = [];
        return;
      }
      this.$request.canvasAiAdminList({ vendor_code: this.activeVendor }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg || "加载失败");
          return;
        }
        this.rows = this.unwrapList(res);
      });
    },
    toggle(row, on) {
      this.$request.canvasAiAdminToggle({ id: row.id, enabled: on ? 1 : 0 }).then((res) => {
        if (res.status != "success") {
          this.$message.error(res.msg);
          return;
        }
        this.$set(row, "enabled", on ? 1 : 0);
      });
    },
    openVendor() {
      const v = this.currentVendor || {};
      this.vendorForm = {
        vendor_code: this.activeVendor,
        base_url: v.base_url || "",
        api_host: v.api_host || "",
        api_key: "",
        api_key_masked: v.api_key_masked || "",
      };
      this.vendorVisible = true;
    },
    saveVendor() {
      this.$request
        .canvasAiAdminSaveVendor({
          vendor_code: this.vendorForm.vendor_code,
          base_url: this.vendorForm.base_url,
          api_host: this.vendorForm.api_host,
          api_key: this.vendorForm.api_key,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.vendorVisible = false;
          this.$message.success("调用信息已保存");
          this.loadVendors();
        });
    },
    openEdit(row) {
      if (row) {
        this.form = {
          id: row.id,
          display_name: row.display_name || row.model_code,
          model_code: row.model_code,
          expire_at: this.dateText(row.expire_at),
          enabledOn: Number(row.enabled) === 1,
          remark: row.remark || "",
        };
      } else {
        this.form = {
          id: "",
          display_name: "",
          model_code: "",
          expire_at: "",
          enabledOn: true,
          remark: "",
        };
      }
      this.dialogVisible = true;
    },
    save() {
      this.$request
        .canvasAiAdminSave({
          id: this.form.id || undefined,
          vendor_code: this.activeVendor,
          display_name: this.form.display_name,
          model_code: this.form.model_code,
          expire_at: this.form.expire_at,
          enabled: this.form.enabledOn ? 1 : 0,
          remark: this.form.remark,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.dialogVisible = false;
          this.$message.success("已保存");
          this.loadModels();
        });
    },
    removeCurrent() {
      this.$confirm("删除后该模型不再参与自动切换", "删除", { type: "warning" })
        .then(() => this.$request.canvasAiAdminDelete({ id: this.form.id }))
        .then((res) => {
          if (!res) return;
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.dialogVisible = false;
          this.$message.success("已删除");
          this.loadModels();
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.canvasAiModelsWrap {
  padding: 20px 24px 32px;
  background: #fff;
  min-height: 480px;
}
.hint {
  margin: 0 0 12px;
  color: #909399;
  font-size: 13px;
}
.toolbar {
  margin-bottom: 16px;
}
.coming {
  text-align: center;
  padding: 80px 0;
  color: #909399;
  i {
    font-size: 40px;
    display: block;
    margin-bottom: 12px;
  }
  p {
    font-size: 16px;
    margin: 0;
  }
}
.card-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}
.model-card {
  width: 168px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 14px 12px 12px;
  cursor: pointer;
  background: #fafbfc;
  &.off {
    opacity: 0.55;
  }
  &:hover {
    border-color: #c6e2ff;
    background: #f5f9ff;
  }
  .icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }
  .name {
    font-size: 13px;
    color: #303133;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .expire {
    margin-top: 4px;
    font-size: 12px;
    color: #909399;
  }
  .switch-row {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #606266;
  }
}
.empty {
  color: #c0c4cc;
  font-size: 13px;
}
</style>
